import React, { useState } from 'react';
import './App.css';
import HealthPanel from './HealthPanel';
import HistoricalCharts from './HistoricalCharts';

function App() {
  const [activeTab, setActiveTab] = useState<'realtime' | 'historical'>('realtime');

  return (
    <div className="App">
      <header className="app-header-bar">
        <div className="header-content">
          <img 
            src="/logonuevo.svg" 
            alt="Depay Logo" 
            className="depay-logo"
          />
        </div>
      </header>

      <div className="tab-navigation">
        <button
          onClick={() => setActiveTab('realtime')}
          className={`tab-button ${activeTab === 'realtime' ? 'active' : ''}`}
        >
          ● Real-Time
        </button>
        <button
          onClick={() => setActiveTab('historical')}
          className={`tab-button ${activeTab === 'historical' ? 'active' : ''}`}
        >
          ◆ Historical
        </button>
      </div>

      {activeTab === 'realtime' ? <HealthPanel /> : <HistoricalCharts />}
    </div>
  );
}

export default App;
